import DefaultDrawer from '../defaultDrawer/DefaultDrawer';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import InfoContentTab from '../../../pages/infoContent/components/InfoContentTab';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';

function TermsDrawer() {
  const { width } = useWindowDimensions();
  const { showTermsModal, setShowTermsModal } = useModal();

  return (
    <DefaultDrawer
      show={width < 1024 && showTermsModal}
      setShow={setShowTermsModal}
      wrapperStyle={{
        height: '70%',
      }}
      className="nav-drawer"
    >
      <InfoContentTab type={showTermsModal} />
    </DefaultDrawer>
  );
}

export default TermsDrawer;
